import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { WebhookInterface } from '@interface/webhook/webhook.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialWebhooksState } from './webhooks.initial-state';

export const webhooksSlice = createSlice({
  name: 'webhooks',
  initialState: initialWebhooksState,
  reducers: {
    ...baseReducerActions(initialWebhooksState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<WebhookInterface[]>>) => {
      state.data = mapifyPayload(payload.data);
    },
    setWebhook: (state, { payload: { data } }: PayloadAction<ResponseDataInterface<WebhookInterface>>) => {
      state.data[data.id] = data;
    },
    removeWebhook: (state, { payload }: PayloadAction<string>) => {
      state.data = Object.fromEntries(Object.entries(state.data).filter(([id]) => id !== payload));
    },
  },
});

export const webhooksActions = webhooksSlice.actions;
